module.exports = __webpack_public_path__ + "static/media/limociousPreview.6f117cb2.jpg";